import {CLOSE_BTN_URL} from "../config/constants";
import {App} from "../app/app";

export class Ad {

    constructor(context, containerId, parameters, ad) {
        this.context = context;
        this.containerId = containerId;
        this.container = document.getElementById(containerId);
        this.parameters = parameters;
        this.ad = ad;
        this.iframeManager = null;
    }

    isParallax() {
        return this.ad.template === "parallax";
    }

    isAdSpace() {
        return this.ad['adspaceWidth'] == '300' && this.ad['adspaceHeight'] == '250';
    }

    buildCloseButton() {
        let positionY = 'top';
        let positionX = 'left';
        if (this.ad['closePosition']) {
            if (this.ad['closePosition'].substring(0, 6) === 'bottom') {
                positionY = 'bottom';
            }
            if (this.ad['closePosition'].substring(this.ad['closePosition'].length - 5) === 'right') {
                positionX = 'right';
            }
        }

        let btn = new Image();
        btn.src = CLOSE_BTN_URL;
        btn.style.display = 'none';
        btn.style.zIndex = '10002';
        btn.style.position = 'absolute';
        btn.style.width = '36px';
        btn.style.height = '36px';
        btn.style[positionY] = '0px';
        btn.style[positionX] = '0px';
        btn.id = this.containerId + 'mpC';
        return btn.outerHTML;
    }

    buildAdChoice() {
        if (this.ad.adchoiceurl && this.ad.adchoiceimg) {
            return "";
        }

        let positionY = 'top';
        let positionX = 'left';
        if (this.ad['adchoiceposition']) {
            if (this.ad['adchoiceposition'].substring(0, 6) === 'bottom') {
                positionY = 'bottom';
            }
            if (this.ad['adchoiceposition'].substring(this.ad['adchoiceposition'].length - 5) === 'right') {
                positionX = 'right';
            }
        }

        const style = {
            zIndex: '10002',
            position: 'absolute',
        };
        style[positionX] = '0px';
        style[positionY] = '0px';

        let link = document.createElement('link');
        link.src = this.ad['adchoiceurl'];
        link.target = '_top';
        Object.entries(style).forEach(
            ([key, value]) => link.style[key] = value
        );
        link.innerHTML = '<img src="' + this.ad.adchoiceimg + '" style="width: 15px;padding: 3px;background-color:rgba(0, 0, 0, 0.6);">'
        return link.outerHTML;
    }

    close() {
        if (this.iframeManager) {
            this.iframeManager.close();
            delete this.iframeManager;
        }

        this.container.parentNode.removeChild(this.container);
        this.container = null;
        App.ads[this.containerId] = null;
        delete App.ads[this.containerId];
    }

    hide() {
        this.container.style.display = 'none';
    }

    show() {
        this.container.style.display = 'block';
    }

    workmedcont(medcont, target) {
        const registr = {
            scriptcont: /<script.*?\/script>/gi,
            jsurl: /src\s*=\s*[\'\"]\s*http[s]*:\/\/.*\.js/gi,
            scripttags: /<[\/]*script[^>]*>/gi
        };
        medcont = medcont.replace(/[\r\n\t]/g, "");
        let scripts = medcont.match(registr.scriptcont, "") || [],
            nodes = [];
        medcont = medcont.replace(/&#rn;/g, "\r\n");
        medcont = medcont.replace(/&#n;/g, "\n");
        medcont = medcont.replace(registr.scriptcont, "");

        for (let iter = 0; iter < scripts.length; iter++) {

            let script = scripts[iter],
                opentag = script.match(/^<[^>]+/)[0],
                attributes = opentag.match(/[a-zA-Z]+\s*=\s*[\'\"][^\'\"]+/gi),
                pass = {};
            script = script.replace(/<\!--.*?\*\//, "");
            script = script.replace(/\/\*.*?\/-->/, "");
            if (attributes) {
                let set = [];
                for (let _iter = 0; _iter < attributes.length; _iter++) {
                    let set = attributes[_iter].replace(/[\'\"\s]/g, '')
                        .split("=");
                    let attr_name = set.shift();
                    let attr_val = set.join("=");
                    pass[attr_name] = attr_val;
                }
            }
            nodes[nodes.length] = [document.createElement("script"), false];

            for (let attr in pass) {
                nodes[nodes.length - 1][0][attr] = pass[attr];
            }

            if (!pass["src"]) {
                script = script.replace(registr.scripttags, "");
                nodes[nodes.length] = [script, true];
            }
        }
        target.innerHTML = target.innerHTML + medcont;
        let the = this;
        document.write = function (append) {
            the.workmedcont(append, target);
        };

        for (let iter = 0; iter < nodes.length; iter++) {
            if (nodes[iter][1]) {
                try {
                    window.eval(nodes[iter][0]);
                } catch (e) {}
            } else {
                target.appendChild(nodes[iter][0]);
            }
        }
    };

}
